import React from 'react';
import { SVGIconProps } from './props';

const HoleSVGIcon = (props: SVGIconProps) => {
    return (
        <span className={props.className}>
            <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M10.2925 8.92113V11.233C10.8888 11.4546 11.2758 11.8069 11.2758 12.2046C11.2758 12.8616 10.2231 13.3976 8.90677 13.4194C8.8792 13.421 8.84995 13.421 8.8207 13.421C8.21236 13.421 7.65773 13.3116 7.22851 13.1298C6.70145 12.9073 6.36704 12.5753 6.36704 12.2046C6.36704 11.8339 6.70145 11.5022 7.22851 11.2797C7.35817 11.225 7.50301 11.1793 7.65404 11.1389V12.4395C7.99351 12.6097 8.43254 12.712 8.91348 12.712C8.93682 12.712 8.95989 12.712 8.98182 12.7104V5.54802L13.8481 3.07252L7.65408 0V8.89721C3.33457 9.18047 0 11.0107 0 13.2291C0 15.6435 3.94963 17.6011 8.82127 17.6011C13.6934 17.6011 17.6431 15.6435 17.6431 13.2291C17.6431 11.0633 14.4632 9.2682 10.2925 8.92113ZM14.4925 15.0013C13.8695 15.0013 13.3647 14.5076 13.3647 13.8985C13.3647 13.2893 13.8695 12.7956 14.4925 12.7956C15.1155 12.7956 15.6203 13.2893 15.6203 13.8985C15.6203 14.5076 15.1155 15.0013 14.4925 15.0013Z'
                    fill={props.front_fill ?? '#31599A'}
                />
            </svg>
        </span>
    );
};

export default HoleSVGIcon;
